import { render, staticRenderFns } from "./LeadDuplicateList.vue?vue&type=template&id=6b1a6af5&scoped=true&"
import script from "./LeadDuplicateList.vue?vue&type=script&lang=js&"
export * from "./LeadDuplicateList.vue?vue&type=script&lang=js&"
import style0 from "./LeadDuplicateList.vue?vue&type=style&index=0&id=6b1a6af5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1a6af5",
  null
  
)

export default component.exports